import React from 'react';
import { noop } from 'lodash';
import classNames from 'classnames';
import { number, bool, func } from 'prop-types';
import { Progressbar } from '@fiverr-private/fit';
import { calculatePercentage, formatSimpleNumber } from '../../../../../../utils';
import FilterButton from './FilterButton';
import './style.scss';

export const StarsCounter = ({ value, rating = 0, total = 0, selected = false, onToggle = noop }) => {
    const noRating = rating === 0;
    const percentage = total ? calculatePercentage(rating, total) : 0;
    const onRatingClick = !noRating ? () => onToggle(selected) : noop;

    return (
        <tr className={classNames({ 'no-rating': noRating })} onClick={onRatingClick}>
            <td>
                <FilterButton noRating={noRating} selected={selected} value={value} rating={rating} />
            </td>
            <td className="progress-bar-container">
                <Progressbar
                    percent={percentage}
                    className="star-progress-bar"
                    progressClassName="star-progress-shape"
                />
            </td>
            <td className="star-num">({formatSimpleNumber(rating)})</td>
        </tr>
    );
};

StarsCounter.propTypes = {
    rating: number,
    total: number,
    selected: bool,
    onToggle: func,
};

export default StarsCounter;
